<template>
  <div class="container">
    <div class="close-container">
      <span class="iconfont iconGroup11" @click="closeImportMask" />
    </div>
    <div class="title-container">
      <div class="title">选择新建简历或导入简历</div>
      <div class="sub-title">丰富简历信息有助于提升求职率</div>
    </div>
    <div v-for="(item, index) in cvCreateData" :class="['create-cv-container', `cv_${index}`]" :key="index" @click="addCv(item.type)" data-growing-container>
      <img :src="item.imageUrl" alt="" class="image">
      <div class="text-container">
        <p>{{ item.title }}</p>
        <p>{{ item.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewCv",
  data() {
    return {
      cvCreateData: [
        {
          title: '新建简历',
          description: '海量行业模板、大牛简历助你求职顺利',
          imageUrl: 'https://files.wondercv.com/cv-list/cv-create.png',
          type: 'template'
        },
        {
          title: '有简历，直接导入',
          description: '支持Word、PDF格式，80%以上内容识别率，自动专业排版',
          imageUrl: 'https://files.wondercv.com/cv-list/cv-import.png',
          type: 'import'
        },
        // {
        //   title: '拍照识别',
        //   description: '支持一页纸长度简历，拍照即可识别文本内容，自动智能排版',
        //   imageUrl: 'https://files.wondercv.com/rn/cv/import/cameraCvIcon.png',
        //   type: 'cameraCv'
        // }
      ]
    }
  },
  methods: {
    closeImportMask() {
      this.$emit('close')
    },
    addCv(type) {
      this.$emit('addOrImportCv', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 600px;
  background-color: #fff;
  border-radius: 12px 12px 0 0;
  box-sizing: border-box;
  padding: 24px;
  .close-container {
    display: flex;
    justify-content: flex-end;
    .iconfont {
      color: #BCBCBC;
    }
  }
  .title-container {
    width: 100%;
    margin-top: 32px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    div {
      //width: 100%;
    }
    .title {
      font-size: 20px;
      font-weight: 500;
      color: #404040;
    }
    .sub-title {
      margin-top: 12px;
      font-size: 14px;
      color: #9c9c9c;
    }
  }
  .create-cv-container {
    width: 327px;
    height: 114px;
    background: #FFFFFF;
    box-shadow: 0 4px 16px 0 rgba(3, 47, 129, 0.08);
    border-radius: 6px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:nth-child(3) {
      margin-top: 46px;
    }
    .image {
      width: 114px;
      height: 100%;
      border-radius: 6px;
      object-fit: contain;
    }
    .text-container {
      width: 60%;
      height: auto;
      box-sizing: border-box;
      padding-right: 24px;
      //background-color: #000;
      p {
        &:first-child {
          line-height: 22px;
          font-size: 16px;
          color: #202329;
          font-weight: 500;
        }
        &:last-child {
          margin-top: 5px;
          line-height: 17px;
          font-size: 12px;
          color: #9c9c9c;
        }
      }
    }
  }
}
</style>